import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularWarning: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_warning"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="warning icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 19"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M8.90934 0.782164C9.94911 0.206251 11.2471 0.540893 11.885 1.5224L11.9678 1.66023L19.7267 15.6685C19.9115 16.0021 20.0085 16.3773 20.0085 16.7587C20.0085 17.9495 19.0833 18.9243 17.9125 19.0035L17.7585 19.0087H2.24272C1.86141 19.0087 1.48636 18.9118 1.15277 18.7271C0.112933 18.1513 -0.292107 16.8734 0.201447 15.812L0.274345 15.6687L8.03114 1.66046C8.23567 1.2911 8.54 0.986735 8.90934 0.782164ZM18.4146 16.3953L10.6556 2.38702C10.4549 2.02467 9.99847 1.89363 9.63612 2.09433C9.54379 2.14547 9.46364 2.21533 9.40058 2.299L9.34339 2.3871L1.5866 16.3954C1.38594 16.7577 1.51704 17.2141 1.87941 17.4148C1.9628 17.461 2.05397 17.4907 2.14797 17.5027L2.24272 17.5087H17.7585C18.1727 17.5087 18.5085 17.1729 18.5085 16.7587C18.5085 16.6633 18.4903 16.5691 18.4552 16.4811L18.4146 16.3953L10.6556 2.38702L18.4146 16.3953ZM10.0004 14.0018C10.5519 14.0018 10.9991 14.4489 10.9991 15.0004C10.9991 15.552 10.5519 15.9991 10.0004 15.9991C9.44885 15.9991 9.00173 15.552 9.00173 15.0004C9.00173 14.4489 9.44885 14.0018 10.0004 14.0018ZM9.99619 6.49955C10.3759 6.49925 10.6899 6.78115 10.7399 7.14718L10.7468 7.24895L10.7504 11.7505C10.7507 12.1648 10.4152 12.5008 10.001 12.5011C9.6213 12.5014 9.30728 12.2195 9.25732 11.8535L9.25039 11.7517L9.24679 7.25015C9.24646 6.83594 9.58198 6.49988 9.99619 6.49955Z" />
      </svg>
    </span>
  );
};

export { RegularWarning };
